import React, { useState, useEffect } from "react";
import { Routes } from "./Routes";
import { setAccessToken } from "./accessToken";
import { LinearProgress } from "@mui/material";
import mainAddr from "./mainAddr";
import { useGetLabelTextMutation } from "./generated/graphql";
import { updateLabels } from "./labelText";

interface Props {}

export const App: React.FC<Props> = () => {
  const [loading, setLoading] = useState(true);
  const [getLabelText] = useGetLabelTextMutation();

  useEffect(() => {
    fetch(`${mainAddr()}/refresh_token`, {
      method: "POST",
      credentials: "include",
    }).then(async (x) => {
      const { accessToken } = await x.json();
      setAccessToken(accessToken);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    (async () => {
      const response = await getLabelText();
      if (response.data && response.data.getLabelText) {
        updateLabels(response.data.getLabelText);
      }
    })();
  }, [getLabelText]);

  if (loading) {
    return <LinearProgress />;
  }

  return <Routes />;
};
